import RpIcon from "@/components/RpIcon";
import { Stack, styled } from "@mui/material";

const StyledWrapper = styled(Stack)(({theme}) => ({
  '.iconfont': {
    padding: '8px 0',
    color: theme.palette.text.primary
  }
}))

export default function CollapseButton({ collapse, onClick }) {
  return (
    <StyledWrapper alignItems={'center'} justifyContent={'center'} onClick={onClick}>
      <RpIcon icon={collapse ? 'arrow-down-simple' : 'arrow-up-simple'} />
    </StyledWrapper>
  );
}
